<template>
  <div>
  </div>
</template>

<script>

export default {
  name: 'UIBase',
  components: {
  },
  data () {
    return {
    };
  },
  mounted () {
  },
  methods: {
    getQueryVariable(){
      let query = window.location.search.substring(1);
      let allVar = query.split("&");
      let splited = [];
      for(let variable of allVar){
        let splitedVar = variable.split("=");
        splited.push(splitedVar);
      }
      return splited;
    }
  }
};

</script>



// WEBPACK FOOTER //
// src/components/UIBase.vue